/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PayerContractRules
 */
export interface PayerContractRules {
    /**
     * Contract rules content as text
     * @type {string}
     * @memberof PayerContractRules
     */
    rules?: string;
}

/**
 * Check if a given object implements the PayerContractRules interface.
 */
export function instanceOfPayerContractRules(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PayerContractRulesFromJSON(json: any): PayerContractRules {
    return PayerContractRulesFromJSONTyped(json, false);
}

export function PayerContractRulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayerContractRules {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rules': !exists(json, 'rules') ? undefined : json['rules'],
    };
}

export function PayerContractRulesToJSON(value?: PayerContractRules | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rules': value.rules,
    };
}

